import {
  UPDATE_RECOLECCION_STATUS_START,
  UPDATE_RECOLECCION_STATUS_SUCCESS,
  UPDATE_RECOLECCION_STATUS_ERROR
} from '../actions'

const initialState = {
  loading: false,
  payload: null,
  error: null,
  draggableId: null
}

const updateStatus = (state = initialState, { type, draggableId, payload, error }) => {
  
  switch(type) {

    case UPDATE_RECOLECCION_STATUS_START:
      return {
        ...state,
        loading: true,
        draggableId,
        error: null
      }

    case UPDATE_RECOLECCION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        payload
      }

    case UPDATE_RECOLECCION_STATUS_ERROR:
      return {
        ...state,
        loading: false,
        error
      }
    
    default: return state

  }

}

export default updateStatus